"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interruptAttack = exports.updateTick = exports.createWeaponStateForEnemy = exports.createWeaponStateForHero = void 0;
var diveSlashEffect_sidecar_1 = require("@dive/effects/diveSlashEffect-sidecar");
var diveBullets_sidecar_1 = require("@dive/entities/diveBullets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveAi_common_sidecar_1 = require("@dive/ai/diveAi_common-sidecar");
var enumsAi_1 = require("@dive/ai/enumsAi");
var diveSplatters_sidecar_1 = require("@dive/effects/diveSplatters-sidecar");
var diveEnums_1 = require("@dive/enums/diveEnums");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
var diveCrew_enemy_data_sidecar_1 = require("./diveCrew_enemy_data-sidecar");
var diveCrew_hero_data_sidecar_1 = require("./diveCrew_hero_data-sidecar");
var diveCrew_misc_sidecar_1 = require("./diveCrew_misc-sidecar");
var diveCrew_movable_sidecar_1 = require("./diveCrew_movable-sidecar");
var diveCrew_weaponData_1 = require("./diveCrew_weaponData");
var diveCrew_weaponData_sidecar_1 = require("./diveCrew_weaponData-sidecar");
function createWeaponStateForHero(heroType) {
    var data = diveCrew_hero_data_sidecar_1.diveCrew_hero_data.find(heroType);
    assert_sidecar_1.assert.notNil(data);
    var weaponState = diveCrew_weaponData_sidecar_1.diveCrew_weaponData.create(data.weaponData);
    return weaponState;
}
exports.createWeaponStateForHero = createWeaponStateForHero;
function createWeaponStateForEnemy(enemyType) {
    var data = diveCrew_enemy_data_sidecar_1.diveCrew_enemy_data.find(enemyType);
    assert_sidecar_1.assert.notNil(data);
    var weaponState = diveCrew_weaponData_sidecar_1.diveCrew_weaponData.create(data.weaponData);
    return weaponState;
}
exports.createWeaponStateForEnemy = createWeaponStateForEnemy;
function updateTick(obj, targetType) {
    // let ds = common.getUpdateDeltaScaled()
    var d = obj.weaponState;
    assert_sidecar_1.assert.notNil(d);
    if (diveCrew_sidecar_1.diveCrew.isUnableToAct(obj)) {
        return;
    }
    // TODO: better way of doing this?
    var frameTime = 1;
    if (d.state === diveCrew_weaponData_1.EDiveWeaponState.Reloading) {
        d.timer += frameTime;
        var reloadTime = d.data.reloadTime;
        if (d.timer >= reloadTime) {
            d.state = diveCrew_weaponData_1.EDiveWeaponState.Ready;
            d.timer = 0;
        }
    }
    var seekRange = d.data.maxDistance;
    // Are we moving?
    var closestTarget = null;
    // TODO: better is moving check
    // Don't allow attacking while moving (todo: dependent on weapon?)
    if (diveCrew_movable_sidecar_1.diveCrew_movable.isNotMoving(obj)) {
        closestTarget = diveAi_common_sidecar_1.diveAi_common.findNearestOrPreferredTarget(obj, {
            type: targetType,
            range: seekRange,
            requireVision: true,
            requireAlive: true,
            requireLineOfFire: true,
        });
    }
    if (closestTarget) {
        // Face towards
        diveCrew_movable_sidecar_1.diveCrew_movable.faceIIJ(obj, closestTarget);
    }
    if (d.state === diveCrew_weaponData_1.EDiveWeaponState.Ready) {
        if (closestTarget) {
            d.state = diveCrew_weaponData_1.EDiveWeaponState.PreAttack1;
            d.timer = 0;
        }
    }
    if (d.state === diveCrew_weaponData_1.EDiveWeaponState.PreAttack1) {
        if (!closestTarget) {
            d.state = diveCrew_weaponData_1.EDiveWeaponState.Ready;
            d.timer = 0;
            return;
        }
        d.timer += frameTime;
        if (d.timer >= d.data.preAttack1Time) {
            d.state = diveCrew_weaponData_1.EDiveWeaponState.PreAttack2;
            d.timer = 0;
        }
        if (d.data.preAttack1Time !== 0) {
            return;
        }
    }
    if (d.state === diveCrew_weaponData_1.EDiveWeaponState.PreAttack2) {
        if (!closestTarget) {
            d.state = diveCrew_weaponData_1.EDiveWeaponState.Ready;
            d.timer = 0;
            return;
        }
        d.timer += frameTime;
        if (d.timer >= d.data.preAttack2Time) {
            // Fire!
            d.state = diveCrew_weaponData_1.EDiveWeaponState.PostAttack;
            d.timer = 0;
            // Melee case
            if (d.data.bulletType === diveEnums_1.EDiveBulletSubtype.MeleeSlash) {
                // Check for block
                var isBlocked = false;
                if (closestTarget.weaponState) {
                    if (closestTarget.weaponState.data.physicalBlockChance) {
                        if (closestTarget.rando.chance(closestTarget.weaponState.data.physicalBlockChance)) {
                            isBlocked = true;
                        }
                    }
                }
                if (isBlocked) {
                    diveCrew_sidecar_1.diveCrew.say(closestTarget, 'Blocked');
                }
                else {
                    var effect = diveSlashEffect_sidecar_1.diveSlashEffect.create(d.data.hitEffect);
                    diveSlashEffect_sidecar_1.diveSlashEffect.moveToIIJ(effect, closestTarget);
                    var enemyState = closestTarget.enemyState;
                    var enemyStateData = enemyState === null || enemyState === void 0 ? void 0 : enemyState.data;
                    // Check resistances
                    var resistance = 0;
                    if (enemyStateData) {
                        resistance = enemyStateData.resistances[d.data.damageType] || 0;
                    }
                    if (resistance > 0.5) {
                        diveCrew_sidecar_1.diveCrew.say(closestTarget, 'Resist');
                    }
                    var damageAmount = d.data.damage;
                    if (resistance >= 1) {
                        damageAmount = 0;
                    }
                    else if (resistance !== 0) {
                        damageAmount = damageAmount * (1 - resistance);
                    }
                    if (enemyStateData) {
                        if (enemyStateData.onHitEffect === enumsAi_1.EDiveOnHitEffect.SlashSplit) {
                            if (d.data.damageType === voyageMessageCrewHurt_1.EVoyageCrewDamageType.Slash) {
                                if (closestTarget.enemyType) {
                                    var newMons = diveAi_common_sidecar_1.diveAi_common.trySpawnMonsterNextTo(closestTarget, closestTarget.enemyType, true);
                                    if (newMons) {
                                        // TODO: how should split hp work?
                                        newMons.hitpoints = closestTarget.hitpoints;
                                    }
                                }
                            }
                        }
                    }
                    if (damageAmount > 0) {
                        diveCrew_sidecar_1.diveCrew.hurt(closestTarget, d.data.damage, d.data.damageType, obj.id);
                        // Add blood effects
                        var splatterTint = diveCrew_misc_sidecar_1.diveCrew_misc.getSplatterTint(closestTarget);
                        var splatterType = diveCrew_misc_sidecar_1.diveCrew_misc.getSplatterType(closestTarget);
                        if (splatterType !== diveEnums_1.EDiveSplatterType.None) {
                            diveSplatters_sidecar_1.diveSplatters.createMultiple(splatterType, 1, closestTarget.i, closestTarget.j, closestTarget.x, closestTarget.y, splatterTint);
                        }
                    }
                }
            }
            var shootAt = function () {
                assert_sidecar_1.assert.notNil(d);
                assert_sidecar_1.assert.notNil(closestTarget);
                diveBullets_sidecar_1.diveBullets.shootAt(d.data.bulletTracking, 0, d.data, obj, closestTarget, (closestTarget === null || closestTarget === void 0 ? void 0 : closestTarget.id) || 0);
            };
            if (d.data.bulletType === diveEnums_1.EDiveBulletSubtype.Fireball) {
                shootAt();
            }
            if (d.data.bulletType === diveEnums_1.EDiveBulletSubtype.Arrow) {
                shootAt();
            }
            if (d.data.bulletType === diveEnums_1.EDiveBulletSubtype.Bullet) {
                shootAt();
            }
        }
    }
    if (d.state === diveCrew_weaponData_1.EDiveWeaponState.PostAttack) {
        d.timer += frameTime;
        if (d.timer >= d.data.postAttackTime) {
            d.state = diveCrew_weaponData_1.EDiveWeaponState.Reloading;
            d.timer = 0;
        }
    }
}
exports.updateTick = updateTick;
function interruptAttack(obj) {
    var d = obj.weaponState;
    if (!d) {
        return;
    }
    d.timer = 0; // Reset our timer
}
exports.interruptAttack = interruptAttack;
